import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ColumnChooser from '../../../../components/ColumnChooser';
import ExcelExportMenu from '../../../../components/ExcelExportMenu';
import { ExcelExportMode } from '../../../../helpers/excelExportRequest';
import { ColumnChooserModel } from '../../../../models/common/ColumnChooserModel';
import { GetDistrictListPagingAndFilterRequest } from '../../../../models/request/district/GetDistrictListPagingAndFilterRequest';
import { RootState } from '../../../../redux/store';
import { MenuComponent } from '../../../../_metronic/assets/ts/components';
import TableConstantActions from '../../../../components/TableConstantActions';

interface Props {
    columns: ColumnChooserModel[]
    setColumns: React.Dispatch<React.SetStateAction<ColumnChooserModel[]>>
    getColumns: () => ColumnChooserModel[]
    pageName: string
    pageVersion: string
    excelExport: (mode: ExcelExportMode) => void
    filter: GetDistrictListPagingAndFilterRequest
    getData: (_filter?: GetDistrictListPagingAndFilterRequest | undefined) => Promise<void>
    setFilter: React.Dispatch<React.SetStateAction<GetDistrictListPagingAndFilterRequest>>
    selectedCount: number
    deleteFunction: () => void
    updateFunction: () => void
    onSearchSubmit: (e: any) => void
}

const DistrictListFilters = ({
    columns,
    setColumns,
    getColumns,
    pageName,
    pageVersion,
    excelExport,
    filter,
    getData,
    setFilter,
    selectedCount,
    deleteFunction,
    updateFunction,
    onSearchSubmit
}: Props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const auth = useSelector((state: RootState) => state.auth)

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
    }, [])

    return (
        <React.Fragment>
            {/* Güncelle / Sil düğmeleri üst şeritte (standart); arama kutusu gizli, kolon filtreleri kullanılır. */}
            <TableConstantActions
                deleteFunction={deleteFunction}
                onSearchSubmit={onSearchSubmit}
                pageName={pageName}
                hideSearch={true}
                searchTerm={filter.searchTerm}
                selectedCount={selectedCount}
                setSearchTerm={(e) => setFilter({ ...filter, searchTerm: e })}
                updateFunction={updateFunction}
            />

            <ColumnChooser
                columns={columns}
                getColumns={getColumns}
                pageName={pageName}
                pageVersion={pageVersion}
                setColumns={setColumns}
            />

            <ExcelExportMenu
                pageName={pageName}
                selectedCount={selectedCount}
                onExport={excelExport}
            />

            {/* Filtreler paneli kaldırıldı (22.09.2026): Ülkesi ve Şehri kolon başlığının
                altındaki filtrede var (şehir tablosu çok büyük olduğu için Şehri ad metniyle aranır). */}

            <React.Fragment>
                {
                    auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName)?.canInsert && (
                        <div className='m-0'>
                            <a
                                onClick={() => navigate('/district/listadd')}
                                className='btn btn-sm fw-bold btn-primary'
                            >
                                Yeni İlçe Ekle
                            </a>
                        </div>
                    )
                }
            </React.Fragment>
        </React.Fragment>
    )
}

export default DistrictListFilters;